import React from "react";
import { Badge } from "@/components/ui/badge";

const STYLES = {
  regolare:      { label: "Regolare",    className: "bg-emerald-50 text-emerald-800 border border-emerald-200" },
  ritardo:       { label: "In ritardo",  className: "bg-red-50 text-red-800 border border-red-200" },
  fermo:         { label: "Fermo",       className: "bg-orange-50 text-orange-800 border border-orange-200" },
  occasionale:   { label: "Occasionale", className: "bg-stone-100 text-stone-700 border border-stone-200" },
  da_ricontattare:{ label: "Da ricontattare", className: "bg-amber-50 text-amber-800 border border-amber-200" },
  // schedule statuses
  attesa:        { label: "In attesa",   className: "bg-stone-100 text-stone-700 border border-stone-200" },
  pagata:        { label: "Pagata",      className: "bg-emerald-50 text-emerald-800 border border-emerald-200" },
  in_ritardo:    { label: "In ritardo",  className: "bg-red-50 text-red-800 border border-red-200" },
  saltata:       { label: "Saltata",     className: "bg-stone-200 text-stone-700 border border-stone-300" },
  attivo:        { label: "Attivo",      className: "bg-emerald-50 text-emerald-800 border border-emerald-200" },
  in_attesa:     { label: "In attesa",   className: "bg-stone-100 text-stone-700 border border-stone-200" },
  sospeso:       { label: "Sospeso",     className: "bg-orange-50 text-orange-800 border border-orange-200" },
  chiuso:        { label: "Chiuso",      className: "bg-stone-200 text-stone-700 border border-stone-300" },
};

export function StatusBadge({ status }) {
  const s = STYLES[status] || { label: status, className: "bg-stone-100 text-stone-700 border border-stone-200" };
  return (
    <Badge className={`rounded-full px-2.5 py-0.5 text-[11px] font-medium tracking-wide ${s.className}`}>
      {s.label}
    </Badge>
  );
}

export const DONOR_TYPE_LABELS = {
  privato: "Privato",
  chiesa: "Chiesa",
  azienda: "Azienda",
  associazione: "Associazione",
  fondazione: "Fondazione",
};

export function DonorTypeBadge({ type }) {
  const colors = {
    privato: "bg-stone-100 text-stone-700 border border-stone-200",
    chiesa: "bg-indigo-50 text-indigo-800 border border-indigo-200",
    azienda: "bg-amber-50 text-amber-800 border border-amber-200",
    associazione: "bg-sky-50 text-sky-800 border border-sky-200",
    fondazione: "bg-violet-50 text-violet-800 border border-violet-200",
  };
  return (
    <Badge className={`rounded-full px-2 py-0.5 text-[10px] uppercase tracking-wider font-semibold ${colors[type] || colors.privato}`}>
      {DONOR_TYPE_LABELS[type] || type}
    </Badge>
  );
}
